import React from 'react';

const HeroSection = () => {
  return (
    <section className="hero" id="home">
      {/* Background Animation */}
      <div className="hero-bg-animation">
        <div className="grid-pattern"></div>
        <div className="floating-elements">
          <div className="float-element"></div>
          <div className="float-element"></div>
          <div className="float-element"></div>
        </div>
      </div>

      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">
            Accelerate Steel R&D with an <span className="gradient-text">AI-Powered Virtual Steel Lab</span>
          </h1>
          <p className="hero-subtitle">
            Predict microstructure, hardness, and heat-treatment outcomes before you run physical trials.
          </p>
          <p className="hero-cta-text">
            Ferritico helps steel engineers design better alloys faster by virtually predicting steel behavior before any heat treatment. Our cloud-based platform combines metallurgical expertise with data-driven machine learning so your team can reduce costly trial-and-error, evaluate options earlier, and focus on innovation.
          </p>
          <div className="hero-buttons">
            <a href="#contact" className="btn-primary">
              Book CCT Demo
            </a>
            <a href="#contact" className="btn-secondary">
              Contact Us
            </a>
          </div>
        </div>

      </div>
    </section>
  );
};

export default HeroSection;
